import React from 'react';
import { CacheProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material/styles';
import { UserProvider } from '../contexts/UserContext';
import { createEmotionCache } from '../utils/emotion-cache';
import theme from '../theme';
const AppProviders = ({ children }) => {
    const emotionCache = React.useRef(createEmotionCache()).current;
    return (React.createElement(CacheProvider, { value: emotionCache },
        React.createElement(ThemeProvider, { theme: theme },
            React.createElement(UserProvider, null, children))));
};
export default AppProviders;
